module.exports = __webpack_public_path__ + "img/RawData.a1a5df40.png";